import { Home, Package, Users, Upload, BookOpen } from 'lucide-react';

export const navigation = [
  { name: 'Home', href: '/', icon: Home },
  { name: 'Apps', href: '/apps', icon: Package },
  { name: 'Developers', href: '/developers', icon: Users },
  { name: 'Upload', href: '/upload', icon: Upload },
  { name: 'Docs', href: '/docs', icon: BookOpen },
];
